const TARGET_PATHS: Record<AuthTarget, string> = {
  wishlists: '/myaccount/wishlists',
}

export function useAuthFlow() {
  const authModalEvt = useEventBus<AuthState>('authModal')
  const localStorage = useLocalStorage<AuthState | undefined>(
    'authState',
    null,
    { serializer: useObjectStorageSerializer() },
  )

  function toggle(status: boolean) {
    updateState({ status })
    authModalEvt.emit(localStorage.value)
  }

  function resetState() {
    localStorage.value = undefined
  }

  function updateState(data: AuthState) {
    localStorage.value = { ...localStorage.value, ...data }
  }

  function subscribe(handler: (state: AuthState) => void) {
    authModalEvt.on(handler)
  }

  function unsubscribe(handler: (state: AuthState) => void) {
    authModalEvt.off(handler)
  }

  function createTargetPath(defaultPath: string = '/') {
    return localStorage.value?.target
      ? TARGET_PATHS[localStorage.value.target]
      : defaultPath
  }

  return {
    currentState: readonly(localStorage),
    toggle,
    resetState,
    updateState,
    subscribe,
    unsubscribe,
    createTargetPath,
  }
}
